import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import * as XLSX from "xlsx";

const FieldIndicatorDetails = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };
  const [loading, setLoading] = useState(false);
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getFieldDaysIndicatorData } = useHttp();

  const fillFieldDaysIndicatorData = (employeeId, getType = "") => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/fieldDaysIndicatorDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getFieldDaysIndicatorData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillFieldDaysIndicatorData(0, 0, "");
  }, [getFieldDaysIndicatorData]);

  const handleExportExcel = () => {
    setLoading(true);
    const filename = "fieldDaysIndicatorDetailReport.xlsx";

    if (!data || data.length === 0) {
      console.error("No data available for export.");
      setLoading(false);
      return;
    }

    const getDownloadUrl = (path) => {
      if (!path) return "";
      const base = process.env.REACT_APP_FILE_URL || "";
      return `${base}${path}`;
    };

    const headers = [
      "Promoter Id",
      "Agri Promoter Name",
      "Doc No",
      "Category of buyers",
      "Buyers name",
      "Gender",
      "Mobile number ",
      "State",
      "LGA",
      "Address",
      "Village Name",
      "Crop cultivated ",
      "Product",
      "Unit",
      "Quantity Purchased",
      "Unit Price(N)",
      "Total Amount(N)",
      "Signature ",
      "Pictures captured",
    ];

    const rows = data.map((item, index) => {
      const signatureUrl = getDownloadUrl(item.signature);
      const imageUrl = getDownloadUrl(item.image);

      return [
        item.employeeCode || "",
        item.employeeName || "",
        item.docNo || "",
        item.categoryOfbuyer || "",
        item.buyerName || "",
        item.gender || "",
        item.mobileNumber || "",
        item.state || "",
        item.lga || "",
        item.address || "",
        item.villageName || "",
        item.cropName || "",
        item.productName || "",
        item.unitName || "",
        item.itemQuantity || "",
        item.itemUnitPrice || "",
        item.amount || "",
        signatureUrl || "No Signature",
        imageUrl || "No Image",
      ];
    });

    const sheetData = [headers, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Field Days Indicator Deatils"
    );

    try {
      XLSX.writeFile(workbook, filename);
    } catch (err) {
      console.error("Excel export failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Days Indicator Details
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillFieldDaysIndicatorData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>Doc No</th>
                          <th>Category of buyers</th>
                          <th>Buyers name</th>
                          <th>Gender</th>
                          <th>Mobile number </th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Address</th>
                          <th>Village Name</th>
                          <th>Crop cultivated </th>
                          <th>Product</th>
                          <th>Unit</th>
                          <th>Quantity Purchased</th>
                          <th>Unit Price(N)</th>
                          <th>Total Amount(N)</th>
                          <th>Signature </th>
                          <th>Pictures captured</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            const products =
                              itm.fieldDetailProducts &&
                              Array.isArray(itm.fieldDetailProducts) &&
                              itm.fieldDetailProducts.length > 0
                                ? itm.fieldDetailProducts
                                : [null];

                            return products.map((prod, j) => (
                              <tr key={`${i}-${j}`} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.employeeCode || ""}</td>
                                <td>{itm.employeeName || ""}</td>
                                <td>{itm.docNo || ""}</td>
                                <td>{itm.categoryOfbuyer || ""}</td>
                                <td>{itm.buyerName || ""}</td>
                                <td>{itm.gender || ""}</td>
                                <td>{itm.mobileNumber || ""}</td>
                                <td>{itm.state || ""}</td>
                                <td>{itm.lga || ""}</td>
                                <td>{itm.address || ""}</td>
                                <td>{itm.villageName || ""}</td>
                                <td>{itm.cropName || ""}</td>
                                <td>{itm.productName || ""}</td>
                                <td>{itm.unitName || ""}</td>
                                <td>{itm.itemQuantity || ""}</td>
                                <td>{itm.itemUnitPrice || ""}</td>
                                <td>{itm.amount || ""}</td>
                                <td>
                                  {itm.signature ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.signature}`}
                                      alt="Signature"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Signature"
                                  )}
                                </td>

                                <td>
                                  {itm.image ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.image}`}
                                      alt="Farmer"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                              </tr>
                            ));
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FieldIndicatorDetails;
